/**
 * @Author: qingliu
 * @Date: 2018-03-13 16:30:36.582
 * @Last Modified by: xinzhong
 * @Last Modified time: 2023-06-01 15:36:54
 */
export default {
    name: 'Index'
};
